export default __webpack_public_path__ + "static/media/262.334c1fca.jpg";